import { STA_COMPANY_ID } from "../../../../helper/companyIdhardcode";

export const excelHeaderDetailed = [
    { header: 'Select City', exportHead: 'Select City', field: 'City', xlCol: { dataType: 'string', dataFormatter: null }, align: 'right',col:5},
    { header: 'Select Branch', exportHead: 'Select Branch', field: 'Branch', xlCol: { dataType: 'string', dataFormatter: null }, align: 'left',col:5 },
    { header: 'Select Branch user', exportHead: 'Select Branch user', field: 'User', xlCol: { dataType: 'number', dataFormatter: null }, align: 'right',col:5},
    { header: 'Payment Type', exportHead: 'Payment Type', field: 'PayType', xlCol: { dataType: 'number', dataFormatter: null }, align: 'right',col:5 },
    { header: 'Payment Mode', exportHead: 'Payment Mode', field: 'PayMode', xlCol: { dataType: 'string', dataFormatter: null }, align: 'right',col:5},
    { header: 'Report View', exportHead: 'Report View', field: 'ReportView', xlCol: { dataType: 'string', dataFormatter: null }, align: 'right',col:5},
]
export const filterHeaderForOwnDelivery = [
  { headerName: 'Select City', dataKey: "City" },
  { headerName: 'Select Branch', dataKey: "Branch" },
  { headerName: 'Select Branch user', dataKey: "User" },
  { headerName: 'Payment Type', dataKey: "PayType" },
  { headerName: 'Payment Mode', dataKey: "PayMode" },
  { headerName: 'Report View', dataKey: "ReportView" },
]
export const excelHeaderSummary = [
    { headerName: 'Select City', exportHead: 'Select City', field: 'City', xlCol: { dataType: 'string', dataFormatter: null }, align: 'right',col:2},
    { headerName: 'Select Branch', exportHead: 'Select Branch', field: 'Branch', xlCol: { dataType: 'string', dataFormatter: null }, align: 'left',col:3 },
    { headerName: 'Select Branch user', exportHead: 'Select Branch user', field: 'User', xlCol: { dataType: 'number', dataFormatter: null }, align: 'right',col:2},
    { headerName: 'Payment Type', exportHead: 'Payment Type', field: 'PayType', xlCol: { dataType: 'number', dataFormatter: null }, align: 'right',col:2 },
    { headerName: 'Payment Mode', exportHead: 'Payment Mode', field: 'PayMode', xlCol: { dataType: 'string', dataFormatter: null }, align: 'right',col:2},
    { headerName: 'Report View', exportHead: 'Report View', field: 'ReportView', xlCol: { dataType: 'string', dataFormatter: null }, align: 'right',col:2},
]
export const OwnSummaryHeaderColumn = [
  { headerName: 'Serial Number', exportHead: 'S/N', field: 'SN', xlCol: { dataType: 'number', dataFormatter: null }, align: 'right', isSortIcon: false },
  { headerName: 'Payment Type', exportHead: 'Payment Type', field: 'PaymentType', xlCol: { dataType: 'string', dataFormatter: null }, align: 'left', isSortIcon: true },
  { headerName: 'Item Units', exportHead: 'Item Units', field: 'Items', xlCol: { dataType: 'number', dataFormatter: null }, align: 'right', isSortIcon: true },
  { headerName: 'Freight Charge', exportHead: 'Freight Charge', field: 'Freight', xlCol: { dataType: 'number', dataFormatter: null }, align: 'right', isSortIcon: true },
  { headerName: 'KM Freight', exportHead: 'KM Freight', field: 'KMFreight', xlCol: { dataType: 'number', dataFormatter: null }, align: 'right', isSortIcon: true },
  { headerName: 'Booking Other Charge ', exportHead: 'Bkg.Oth. Charge ', field: 'BkgOtherCharges', xlCol: { dataType: 'number', dataFormatter: null }, align: 'right', isSortIcon: true },
  { headerName: 'Delivery Cartage', exportHead: 'Delivery Cartage', field: 'DeliveryCartage', xlCol: { dataType: 'number', dataFormatter: null }, align: 'right', isSortIcon: true },
  { headerName: 'Delivery Hamali', exportHead: 'Delivery Hamali', field: 'DeliveryHamali', xlCol: { dataType: 'number', dataFormatter: null }, align: 'right', isSortIcon: true },
  { headerName: 'Extra Hamali', exportHead: 'Extra Hameli', field: 'ExtraHamali', xlCol: { dataType: 'number', dataFormatter: null }, align: 'right', isSortIcon: true },
  { headerName: 'Demurrage Charge', exportHead: 'Demurrage Charge', field: 'DemurrageChg', xlCol: { dataType: 'number', dataFormatter: null }, align: 'right', isSortIcon: true },
  { headerName: 'Delivery GST', exportHead: 'Delivery GST', field: 'DeliveryGST', xlCol: { dataType: 'number', dataFormatter: null }, align: 'right', isSortIcon: true },
  { headerName: 'Delivery Discount (-)', exportHead: 'Del.Discount (-)', field: 'DeliveryDisc', xlCol: { dataType: 'number', dataFormatter: null }, align: 'right', isSortIcon: true },
  { headerName: 'Net Amount', exportHead: 'Net Amount', field: 'NetAmount', xlCol: { dataType: 'number', dataFormatter: null }, align: 'right', isSortIcon: true },
]
export const calculateDynamicFormatLandscape = (desiredWidth) => {
  // Standard A4 landscape aspect ratio: width / height = 297 / 210
  const a4LandscapeAspectRatio = 1122 / 793;

  // Calculate the height based on the aspect ratio
  const dynamicHeight = Math.round(desiredWidth / a4LandscapeAspectRatio);

  return [desiredWidth, dynamicHeight];
};
export const calculateDynamicFormatPortrait = (desiredWidth) => {
  // Standard A4 Portrait aspect ratio: width / height = 297 / 210
  const a4LandscapeAspectRatio = 793 / 1122;

  // Calculate the height based on the aspect ratio
  const dynamicHeight = Math.round(desiredWidth / a4LandscapeAspectRatio);

  return [desiredWidth, dynamicHeight];
};
export const calculateTotalTableWidth = (columns) => {
  let totalWidth = 0;

  columns.forEach((column) => {
    const minCellWidth = column.pdfColSx.minCellWidth;
    totalWidth += minCellWidth;
  });

  return totalWidth;
};

export const generateDynamicColumnStyles = (columnCount, Size) => {
  let columnStyles = {};
  let columnIndex = 0
  // Iterate through each header configuration in BranchTransferHeader
  columnCount.forEach((headerConfig) => {
    if (headerConfig?.isSelected) {
      columnStyles[columnIndex] = { ...headerConfig?.pdfColSx,["fontSize"]: Size };
      columnIndex += 1
    }

  });

  return columnStyles;
}
export const ownDeliveryUpdatedColumn =(allowFormatLR,loginCountryId, intCompanyID)=>{
  const lrCols = [];
  if (allowFormatLR === 3) {
    lrCols.push({
      id: 1,
      header: "LR No.\nMan. LR No.",
      exportHead: "LR Number\nManual LR Number",
      field: "LRNO^^ManualLRNo",
      isSelected: true, isDefault: true, isMandatory: true,
      xlCol: { dataType: "string", dataFormatter: null },
      pdfColSx: { halign: "left", textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: "Roboto", valign: "top", minCellHeight: 36 },
      headerSx: { textAlign: "left" },
      isSortIcon: true
    });
    lrCols.push({
      id: 2,
      header: "Formatted LR No",
      exportHead: "Formatted LR Number",
      field: "FormattedLRNO",
      isSelected: true, isDefault: true, isMandatory: false,
      xlCol: { dataType: "string", dataFormatter: null },
      pdfColSx: { halign: "left", textColor: [0, 0, 0], fontSize: 16, minCellWidth: 90, cellPadding: 6, font: "Roboto", valign: "top", minCellHeight: 36 },
      headerSx: { textAlign: "left" },
      isSortIcon: true
    });
  }
  else if (allowFormatLR === 2) {
    lrCols.push({
      id: 1,
      header: "LR No.",
      exportHead: "LR Number",
      field: "LRNO",
      isSelected: true, isDefault: true, isMandatory: true,
      xlCol: { dataType: "string", dataFormatter: null },
      pdfColSx: { halign: "left", textColor: [0, 0, 0], minCellWidth: 80, cellPadding: 6, font: "Roboto" },
      headerSx: { textAlign: "left" },
      isSortIcon: true
    });
    lrCols.push({
      id: 2,
      header: "Formatted LR No",
      exportHead: "Formatted LR Number",
      field: "FormattedLRNO",
      isSelected: true, isDefault: true, isMandatory: false,
      xlCol: { dataType: "string", dataFormatter: null },
      pdfColSx: { halign: "left", textColor: [0, 0, 0], minCellWidth: 90, cellPadding: 6, font: "Roboto" },
      headerSx: { textAlign: "left" },
      isSortIcon: true
    });
  }
  else {
    lrCols.push({
      id: 1,
      header: "LR No.\nMan. LR No.",
      exportHead: "LR Number\nManual LR Number",
      field: "LRNO^^ManualLRNo",
      isSelected: true, isDefault: true, isMandatory: true,
      xlCol: { dataType: "string", dataFormatter: null },
      pdfColSx: { halign: "left", textColor: [0, 0, 0], minCellWidth: 120, cellPadding: 6, font: "Roboto" },
      headerSx: { textAlign: "left" },
      isSortIcon: true
    });
  }
  return [
  {
    id: 0, header: 'S/N', exportHead: 'Serial Number', field: 'SN', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 31, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' },
    isSortIcon: false
  },
  ...lrCols,
  [STA_COMPANY_ID].includes(intCompanyID) && {
    id: 22, header: 'Rcvg. Date\nRcvg. Time', exportHead: 'Receive Date\nReceive Time', field: 'ReceivingDate', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 85, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' },
    isSortIcon: true
  },
  {
    id: 2, header: 'Del. Date\nDel. Time', exportHead: 'Delivery Date\nDelivery Time', field: 'DelDateTime', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 81, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' },
    isSortIcon: true
  },
  {
    id: 3, header: 'Src. City\nSrc. Br.', exportHead: 'Source City\nSource Branch', field: 'SourceCity^^SourceBranch', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 80, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' },
    isSortIcon: true
  },
  {
    id: 4, header: 'Disp. By City\nDisp. By Br.', exportHead: 'Dispatch By City\nDispatch By Branch', field: 'DispatchedByCity^^DispatchedByBranch', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 81, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' },
    isSortIcon: true
  },
  {
    id: 5, header: 'Sndr. Name\nSndr. Cont.', exportHead: 'Sender Name\nSender Contact', field: 'Sender^^SenderMobileNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 81, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' },
    isSortIcon: true
  },
  {
    id: 6, header: loginCountryId === 2 ? 'Sndr. eMail' : 'Sndr. GSTIN\nSndr. eMail', exportHead: loginCountryId === 2 ? 'Sender EMail' : 'Sender GSTIN\nSender EMail', field: loginCountryId === 2 ? 'SenderEmailID' : 'SenderGSTN^^SenderEmailID', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 80, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' },
    isSortIcon: true
  },
  {
    id: 7, header: 'Rcvr. Name\nRcvr. No.', exportHead: 'Receiver Name\nReceiver Number', field: 'RecName^^RecMobileNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 80, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' },
    isSortIcon: true
  },
  {
    id: 8, header: loginCountryId === 2 ? 'Rcvr. eMail' : 'Rcvr. GSTIN \nRcvr. eMail', exportHead: loginCountryId === 2 ? 'Receiver EMail' : 'Receiver GSTIN \nReceiver EMail', field: loginCountryId === 2 ? 'RecEmailID' : 'RecGSTN^^RecEmailID', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 81, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' },
    isSortIcon: true
  },
  {
    id: 9, header: 'Del. By\nItem', exportHead: 'Delivery By\nItem', field: 'DeliveredBy^^ItemDetails', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' },
    isSortIcon: true
  },
  {
    id: 10, header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'Unit', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 48, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' },
    isSortIcon: true
  },
  {
    id: 11, header: 'Frt.\nChrg.', exportHead: 'Freight\nCharge', field: 'FrtChrge', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 49, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' },
    isSortIcon: true
  },
  {
    id: 12, header: 'KM\nFrt.', exportHead: 'Kilometre\nFreight', field: 'KMFrtChrge', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 46, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' },
    isSortIcon: true
  },
  {
    id: 13, header: 'Bkg.\nOth', exportHead: 'Booking\nOther', field: 'BkgOthChrge', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 54, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' },
    isSortIcon: true
  },
  [STA_COMPANY_ID].includes(intCompanyID) && {
    id: 21, header: 'LR Bkg.\nTot. Amt.', exportHead: 'LR Booking\nTotal Amount', field: 'BookingNetAmount', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 70, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' },
    isSortIcon: true
  },
  {
    id: 14, header: 'Del.\nCart.', exportHead: 'Delivery\nCartage', field: 'DelCart', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 48, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' },
    isSortIcon: true
  },
  {
    id: 15, header: 'Del.\nHam.', exportHead: 'Delivery\nHamali', field: 'DelHam', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 48, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' },
    isSortIcon: true
  },
  {
    id: 16, header: 'Ext.\nHam.', exportHead: 'Extra\nHamali', field: 'ExtHam', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 48, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' },
    isSortIcon: true
  },
  {
    id: 17, header: 'Dem.\nChrg.', exportHead: 'Demurrage\nCharge', field: 'DemChrge', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 47, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' },
    isSortIcon: true
  },
  loginCountryId!==2&&{
    id: 18, header: 'Del.\nGST', exportHead: 'Delivery\nGST', field: 'DelGST', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 49, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' },
    isSortIcon: true
  },
  {
    id: 19, header: 'Del.\nDisc.', exportHead: 'Delivery\nDiscount', field: 'DelDisc', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 47, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' },
    isSortIcon: true
  },
  {
    id: 20, header: 'Net\nAmt.', exportHead: 'Net\nAmount', field: 'NetAmt', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'right' },
    isSortIcon: true
  },
   {
    id: 23, header: 'Remarks', exportHead: 'Remarks', field: 'DeliveryRemarks', isSelected: true, isDefault: true, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { textAlign: 'left' },
    isSortIcon: true
  },
].filter(Boolean)
}